export { default as consultationFragment } from './consultation-fragment';
export { default as createOneConsultationMutation } from './create-one-consultation-mutation';
export { default as findByIdConsultationQuery } from './find-by-id-consultation-query';
export { default as removeByIdConsultationMutation } from './remove-by-id-consultation-mutation';
export { default as updateByIdConsultationMutation } from './update-by-id-consultation-mutation';
